import { Box, Typography } from '@mui/material';

type MenusStoresProps = {
  stores: {
    storeId: string;
    title: string;
    smallImage: string[] | null;
  }[];
};

const MenusStores = ({ stores }: MenusStoresProps) => {
  return (
    <Box data-testid="MenusStores">
      {stores?.length === 1 && <Typography>{stores[0]?.title}</Typography>}
      {stores?.length > 1 && (
        <Typography>{`${stores[0]?.title}, +${stores?.length - 1}`}</Typography>
      )}
    </Box>
  );
};

export default MenusStores;
